"use strict";

exports.__esModule = true;
exports["default"] = CirclePlus;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function CirclePlus(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.004.063C7.213.063.063 7.215.063 16.004c0 8.785 7.15 15.934 15.941 15.934 8.787 0 15.934-7.149 15.934-15.934 0-8.789-7.147-15.941-15.934-15.941zm7.976 18.103h-5.819v5.821a2.168 2.168 0 0 1-4.336 0v-5.821h-5.81a2.163 2.163 0 0 1-2.161-2.161 2.17 2.17 0 0 1 2.161-2.172h5.81V8.019c0-1.196.974-2.168 2.17-2.168a2.17 2.17 0 0 1 2.166 2.168v5.814h5.819c1.194 0 2.166.972 2.166 2.163a2.172 2.172 0 0 1-2.166 2.17z"
  }));
}